export class Modal {
  private triggers;
  private close;
  private modals;
  private modalInners;
  private closeBtn;

  constructor() {
    if (document.querySelectorAll('.modal')) {
      this.triggers = document.querySelectorAll('.js-modal');
      this.close = document.querySelectorAll('.js-close-modal');
      this.modals = document.querySelectorAll('.modal');
      this.closeBtn = document.querySelectorAll('.js-modal-closeBtn');
      this.modalInners = document.querySelectorAll('.modal-inner');
      this.listeners();
    }
  }

  listeners() {
    this.triggers.forEach((el) => {
      el.addEventListener('click', this.openModal, false);
    });

    this.modals.forEach((el) => {
      el.addEventListener('transitionend', this.revealModal, false);
      el.addEventListener('click', this.backdropClose, false);
    });

    this.close.forEach((el) => {
      el.addEventListener('click', Modal.hideModal, false);
    });

    this.modalInners.forEach((el) => {
      el.addEventListener('transitionend', this.closeModal, false);
    });

    this.closeBtn.forEach((el) => {
      el.addEventListener('click', Modal.hideModal, false);
    });
  }

  backdropClose(el) {
    if (!el.target.classList.contains('js-modal')) {
      return;
    }

    let backdrop = el.currentTarget.dataset.backdrop !== undefined ? el.currentTarget.dataset.backdrop : true;
    if (backdrop === true) {
      Modal.hideFirstModal();
    }
  }

  openModal(el) {
    if (!el.currentTarget.dataset.modal) {
      console.error('No data-modal attribute defined!');
      return;
    }

    let modalID = el.currentTarget.dataset.modal;
    let modal = document.getElementById(modalID);

    document.body.classList.add('modal-body');
    if (modal) {
      modal.classList.add('modal-visible');
    }
  }

  revealModal(el) {
    if ('opacity' === el.propertyName && el.target.classList.contains('modal-visible')) {
      el.target.querySelector('.modal-inner').classList.add('modal-reveal');
    }
  }

  closeModal(el) {
    if ('opacity' === el.propertyName && !el.target.classList.contains('modal-reveal')) {
      //check if the modal has video and stop it from playing
      Modal.stopVideoFromPlaying();
      const modal = document.querySelector('.modal-visible');
      if (modal) {
        modal.classList.remove('modal-visible');
      }
    }
  }

  static stopVideoFromPlaying() {
    const videoIframe = document.querySelector('iframe') || document.querySelector('video');
    if (videoIframe) {
      if (videoIframe instanceof HTMLVideoElement) {
        videoIframe.pause();
      } else {
        videoIframe.setAttribute('src', '');
      }
    }
  }

  static modalBody(el) {
    if ('opacity' === el.propertyName && el.target.classList.contains('modal') && !el.target.classList.contains('modal-visible')) {
      document.body.classList.remove('modal-body', 'modal-fadeOut');
    }
  }

  static hideFirstModal() {
    let modalOpen = document.querySelector('.modal-visible');
    if (modalOpen) {
      modalOpen.querySelector('.modal-inner')!.classList.remove('modal-reveal');
    }
  }

  static hideModal() {
    let modalOpen = document.querySelector('.modal-visible');
    if (modalOpen) {
      modalOpen.querySelector('.modal-inner')!.classList.remove('modal-body', 'modal-reveal');
    }
    document.body.classList.remove('modal-body', 'modal-fadeOut');
  }
}
